import { useEffect, useState } from 'react';
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from '@stripe/react-connect-js';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import Spinner from '../Spinner/Spinner.jsx';
import { useSearchParams } from 'react-router';

const StripeWidget = () => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);
  const [searchParams] = useSearchParams();
  const secretKey = searchParams.get('secret_key');

  useEffect(() => {
    const instance = loadConnectAndInitialize({
      publishableKey: process.env.REACT_APP_STRIPE_INSTANCE_PUBLISHABLE_KEY,

      fetchClientSecret: async () => {
        return secretKey;
      },
    });

    setStripeConnectInstance(instance);
  }, [secretKey]);

  if (!stripeConnectInstance) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: '30px 400px' }} className="h-screen w-screen">
      <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
        <ConnectAccountOnboarding />
      </ConnectComponentsProvider>
    </div>
  );
};

export default StripeWidget;
